<div class="widget-container" #staticListDiv>
    <loading *ngIf="loader"></loading>
    <!-- Headings -->
    
    <div>
        <icon-chart 
            [headerConfig]="item.config?.['widget_header_config']"
            [data]="this.rowData"
            [pageKey]="pageKey"
            [chartName]="'GridList'" 
            [config]="gridList"
            [item]="item"
        ></icon-chart>

    </div>

    <br>

    <!-- Grid -->
    <div #gridList>
        <ag-grid-angular 
            style="width:100%;" 
            class="ag-theme-balham" 
            #agGrid
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef" 
            [rowStyle]="rowStyle" 
            [animateRows]="true"
            [rowHeight]="rowHeight"
            [tooltipMouseTrack]="true" 
            [cacheQuickFilter]="true"
            [excludeHiddenColumns]="true"
            [pagination]="false" 
            [defaultExcelExportParams]="defaultExportParams"
            [rowData]="rowData"
            [suppressDragLeaveHidesColumns]="true"
            (gridReady)="onGridReady($event)" 
        >
        </ag-grid-angular>
    </div>

</div>